import { render, staticRenderFns } from "./QuillTextEditor.vue?vue&type=template&id=0f045fb6"
import script from "./QuillTextEditor.vue?vue&type=script&lang=js"
export * from "./QuillTextEditor.vue?vue&type=script&lang=js"
import style0 from "./QuillTextEditor.vue?vue&type=style&index=0&id=0f045fb6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports